"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastInfoChat = void 0;
const mappers_1 = require("../../mappers");
const models_1 = require("../../models");
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
const Chat_1 = __importDefault(require("../Chat"));
class BroadcastInfoChat extends Chat_1.default {
    constructor(chat, organizationUser, config, httpAdapter, socketAdapter, userDirectory, chatInfoFetcher) {
        super(chat, organizationUser, config, httpAdapter, socketAdapter, userDirectory, chatInfoFetcher);
    }
    getChatId() {
        return this.chatInfo.id;
    }
    getChatType() {
        return models_1.CHAT_TYPE.BROADCAST;
    }
    updateGroupListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UPDATE_GROUP, this.getChatId()), (data) => {
            const broadcastInfo = data.info;
            const mappedInfo = (0, mappers_1.broadcastInfoMapper)(broadcastInfo, this.userDirectory, this.organizationUser, this.httpAdapter, this.socketAdapter);
            const mappedInfoExceptUndefined = JSON.parse(JSON.stringify(mappedInfo));
            this._chatInfo = Object.assign(Object.assign({}, this._chatInfo), mappedInfoExceptUndefined);
            cb(this);
        });
    }
    openFilteredChat() {
        throw new Error("Not Applicable!");
    }
}
exports.BroadcastInfoChat = BroadcastInfoChat;
